import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { closeModal } from "reducers/Modal";
import { Button, Modal } from "rhombus-react";

export default function ImportDecisionSheetErrorModal(error) {
	const errors = error?.data;
	const dispatch = useDispatch();

	function onClose(){
		dispatch(closeModal());
	}

	function renderContent() {
		const columnHeadings = [
			{ heading:"Error Message" }
		];
		const headingRow = columnHeadings.map((col) => {
			return (
				<th
					className={`error-col`}
					scope="col"
					key={col.heading}
				>
					{col.heading}
				</th>
			);
		});

		const errorRows = Object.keys(errors).map((key) => {
			return (
				<tr key={`decsion-sheet-import-error-${key}`} className="import-error-row">
					<td>
						<span>{errors[key]}</span>
					</td>
				</tr>
			);
		});

		return (
			<div className="import-versions-error-modal-body">
				<div className="info">
					The following errors were encountered during import, no
					changes were made. Please adjust your spreadsheet
					accordingly and try again.
				</div>
				<table className="basic-table">
					<thead>
						<tr>{headingRow}</tr>
					</thead>
					<tbody>{errorRows}</tbody>
				</table>
			</div>
		);
	}

	function renderFooter() {
		return (
			<Button
				theme="default"
				onClick={onClose}
			>
				Close
			</Button>
		);
	}

	const modalProps = {
		title: `Error Importing Decision Sheet`,
		type: "modal",
		className: "import-versions-error-modal",
		xClose: true,
		allowFullScreen: false,
		setAppTitle: false,
		bladeProps: {
			verticallyCenter: true,
		},
		headerProps: {
			icon: "clearCircle",
			className: "bulk-import-error",
		},
		onClose,
		renderContent,
		renderFooter,
	};

	return <Modal {...modalProps} />;
}

ImportDecisionSheetErrorModal.displayName = "ImportDecisionSheetErrorModal";
ImportDecisionSheetErrorModal.propTypes = {
	data: PropTypes.array,
};
ImportDecisionSheetErrorModal.defaultProps = {
	data: ["An unknown error has occured."],
};
